import { BaseApi } from './base.api.js';

export class BcmInitialResponseLibraryApi extends BaseApi {
    constructor(client) {
        super(client, '/bcm-initial-response-library');
    }
}
